import update from 'immutability-helper';
import {
  GET_HOME_HUB_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  homeHub: [],
};

const homeHub = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME_HUB_SUCCESS:
      return update(state, {
        homeHub: {
          $set: action.payload.homeHubItems,
        },
      });
    default:
      return state;
  }
};

export default homeHub;
